import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type RoadmapStats = {
    vmCount: number
    evidenceCount: number
    activityCount: number
    deliverableCount: number
    activityByWeek: Record<string, number>
    lastModified: string | null
}

export type RoadmapStatsResponse = {
    success: boolean
    data: RoadmapStats
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminRoadmapStatsQuery = (roadmapId: string, enabled: boolean = true) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getRoadmapStats = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(`/api/admin/roadmaps/${roadmapId}/stats`, 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching roadmap stats:', e)
            throw e
        }
    }

    return useQuery<RoadmapStatsResponse>(['admin', 'roadmap-stats', roadmapId], getRoadmapStats, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!roadmapId && enabled,
        cacheTime: FIVE_MINUTES,
        staleTime: 60000, // 1 minute stale time for stats
        retry: 2,
    })
}
